import { Rocket } from "lucide-react";
import { PageHeader } from "@/components/shared/page-header";
import { useSession } from "@/lib/auth-client";

export function DashboardPage() {
  const { data: session } = useSession();

  return (
    <>
      {/* Welcome section */}
      <PageHeader
        title={`Welcome back, ${session?.user.name ?? "User"}`}
        description={session?.user.email}
        className="mb-6"
      />

      {/* Empty state */}
      <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-border/60 py-20 text-center">
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
          <Rocket className="h-6 w-6 text-primary" />
        </div>
        <h2 className="text-lg font-semibold">Nothing here yet!</h2>
        <p className="mt-1 max-w-sm text-sm text-muted-foreground">
          This is your blank canvas. Time to start building!
        </p>
      </div>
    </>
  );
}
